export const COLUMN_PREFIX_CLS = 'fw-col';
export const ROW_PREFIX_CLS = 'fw-row';
export const GUTTER = 16;
